export default {
    // baseURL: 'http://localhost:1020', // desarrollo
    // baseURL: 'https://10.125.30.120:7979', // pruebas
    baseURL: 'https://civii.quipux.com', // producion
    civiiChat: {
        weakUnderstandingPercentajeLimit: 45,
        imLostMessage: 'Sinceramente estoy algo perdida. ¿Quisieras hablar directamente con un humano?',
        weakUnderstandingAttemps: 3,
        keepTalkingWithCiviiMessage: 'Puedes seguir hablando conmigo, intentaré dar solución a todas tus preguntas.',
        dataUsageMessage: 'Los datos que ingresaras a continuación son para el buen funcionamiento de la comunicación con el asesor y poder brindarte un mejor servicio.',
        feedbackMessage: 'Aquí estoy yo de nuevo, cuéntame ¿cómo te fue con el agente? Puedes hacerlo presionando click en el emoji que más identifique tu satisfacción, además si quieres tener registro de la conversación, puedes darme tu email para enviartela o descargarla.',
        goodbyeMessage: 'Gracias por tu feedback, puedes seguir hablando conmigo de ahora en adelante'
    },
    menuItems: [{
        title: 'Consultas',
        messages: []
    }],
    isAlwaysActive: false,
    workspace: 'test',
    showBubbleMessages: true,
    bubbleMessageAfterClose: 'Si necesita algo más no dude en decírmelo',
    bubbleMessages: [
        '¡Resolver tus dudas es mi actividad favorita! Escríbeme cuando lo necesites.',
        '¡Qué bueno tenerte por aquí! Haz clic sobre mí si tienes alguna duda.',
        '¡Hola! Conmigo puedes realizar consultas sencillas acerca de tus trámites.',
        '¡Escríbeme! Tus preguntas son valiosas y conmigo tendrás siempre una respuesta.',
        '¡Soy CIVii y las consultas sobre trámites de movilidad son mi fuerte! Escríbeme cuando lo desees.',
        '¿Dudas sobre alguno de los trámites? Haz clic sobre mí para ayudarte.',
        '¡Hola! Estoy aquí para resolver tus dudas...Cuenta conmigo.'
    ],
    bubbleMessageTime: 8000, // time between bubble messages
    bubbleMessageInterval: 16000, // how long the messages last
    bubbleMessageDelay: 3000, // the time the first message lasts visible
    askMoreMessages: [
        '¿Desea que le ayude con algo más?',
        '¿Hay algo más en lo que pueda ayudarlo?',
        'Puede hacerme otra pregunta si lo desea',
        '¿En qué otra cosa puedo ayudarle?',
        '¿Tiene otra pregunta para mi?'
    ],
    options: {
        'yes/no-automatic': {
            yesAnswer: '¡Gracias por consultar!',
            NoAnswer: 'Intentaré responderle mejor la próxima vez.',
            question: '¿Le fue útil esta información?'
        }
    },
    titleButtonVolumenUp: 'Silenciar',
    tittleButtonVolumenOff: 'Activar Sonido',
    titleButtonEraser: 'Borrar chat',
    inputPlaceholder: 'Escriba un mensaje...',
    optionsLabel: 'Opciones',
    openAtStart: false,
    full_size: false,
    show_back: false,
    saved_answers: {
        messageAfterSuggestion: {
            json_response: [{
                type: 'Normal',
                side: 'left',
                messages: [
                    { text: 'Muchas gracias por la sugerencia. La tendré en cuenta para brindarle un mejor servicio en el futuro' }
                ]
            }]
        }
    },
    onTurnedOffStatusTimeout: 10000,
    onTurnedOffStatusMessage: 'Lo lamento, he recibido la orden de apagarme, así que no podre solucionar tus dudas por ahora, cerraré la ventana del chat, pero prontamente estaré de vuelta.',
    serverErrorMessage: 'En este momento la conexión con el servidor está presentando fallas y eso me impide atenderlo. Por favor, inténtelo más tarde.',
    askFeedbackMessage: '¿Te he respondido correctamente?',
    positiveAnswerMessage: 'Me alegra mucho poder ayudarte, si deseas algo más estoy para servirte',
    accordionChecklistPlaceholder: 'Buscar',
    restartAfterLastInteraction: null,
    alwaysReset: false
}


// WEBPACK FOOTER //
// ./src/defaultConfig.js